type TimeSlot = {
  fromDateTime: string,
  toDateTime: string
}
export const filterTimeSlots = (timeSlots: TimeSlot[], hour: number = 12, minutes: number = 0) => {
  return timeSlots.filter((t: TimeSlot) => {
    const dateObj = new Date(t.fromDateTime)
    if (dateObj.getHours() < hour || (dateObj.getHours() === hour && dateObj.getMinutes() === minutes)) {
      return t
    } else {
      return false
    }
  })
} 